import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a9a8f14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Specifications" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "产品规格", -1))
const _hoisted_4 = { class: "specifications" }
const _hoisted_5 = { class: "specificationsItemTitle" }
const _hoisted_6 = {
  key: 0,
  class: "specificationsRange"
}
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "—", -1))
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = {
  key: 1,
  class: "specificationsInput"
}
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = {
  key: 2,
  class: "specificationsSelect"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "comfrim" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanPopup = _resolveComponent("VanPopup")!
  const _component_VanPicker = _resolveComponent("VanPicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanPopup, {
      class: "SpecificationsPopup",
      show: $setup.props.show,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($setup.props.show) = $event)),
      closeable: "",
      style: {"top":"40%"},
      onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit("update:show",false)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.attr, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "specificationsItem",
                key: idx
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
                (item.attributeType=="range")
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "请输入",
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => (($setup.data[idx].value[0]) = $event)
                      }, null, 8, _hoisted_7), [
                        [_vModelText, $setup.data[idx].value[0]]
                      ]),
                      _hoisted_8,
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "请输入",
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => (($setup.data[idx].value[1]) = $event)
                      }, null, 8, _hoisted_9), [
                        [_vModelText, $setup.data[idx].value[1]]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (item.attributeType=="input")
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "请输入",
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => (($setup.data[idx].value) = $event)
                      }, null, 8, _hoisted_11), [
                        [_vModelText, $setup.data[idx].value]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (item.attributeType=="select")
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", {
                        class: "select",
                        onClick: ($event: any) => {$setup.isPickerShow = true;$setup.pickerIdx = idx}
                      }, _toDisplayString($setup.data[idx].value||'请选择'), 9, _hoisted_13)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_VanButton, {
              type: "primary",
              color: "#FEC64B",
              size: "small",
              onClick: $setup.confirm
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_VanPopup, {
      show: $setup.isPickerShow,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (($setup.isPickerShow) = $event)),
      style: {"width":"100vw"},
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_VanPicker, {
          title: "标题",
          columns: $setup.pickerColumns($props.attr[$setup.pickerIdx].options),
          onConfirm: $setup.confirmPicker,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => ($setup.isPickerShow = false))
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}